import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-premium-loading',
  templateUrl: './premium-loading.component.html',
  styleUrls: ['./premium-loading.component.scss']
})
export class PremiumLoadingComponent implements OnChanges, OnDestroy {
  @Input() show: boolean = false;
  @Input() message: string = 'Cargando contenido...';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() minDisplayTime: number = 600; // Tiempo mínimo de visualización en ms

  public displayLoader: boolean = false;
  private loadingStartTime: number = 0;
  private hideTimeout: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show']) {
      if (this.show) {
        this.showLoader();
      } else {
        this.hideLoader();
      }
    }
  }

  private showLoader(): void {
    this.loadingStartTime = Date.now();
    this.displayLoader = true;
  }

  private hideLoader(): void {
    const elapsedTime = Date.now() - this.loadingStartTime;
    const remainingTime = Math.max(0, this.minDisplayTime - elapsedTime);

    // Si no ha pasado el tiempo mínimo, esperar
    if (remainingTime > 0) {
      this.hideTimeout = setTimeout(() => {
        this.displayLoader = false;
      }, remainingTime);
    } else {
      this.displayLoader = false;
    }
  }

  ngOnDestroy(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }
}